import {
  createUserApi,
  deleteUserApi,
  getAllUsersApi,
  getUserByIdApi,
  updateUserApi,
} from "../../helpers/backend_helper";
import {
  errorMessages,
  getUsersList,
  setLoading,
  userByIdData,
} from "./reducer";

export const getAllUsersList = (currentPage, pageSize, searchText) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "read", value: true }));
    let response;
    response = getAllUsersApi(currentPage, pageSize, searchText);
    const data = await response;
    dispatch(getUsersList(data));
  } catch (error) {
    dispatch(errorMessages("Some thing went wrong, please try later"));
  } finally {
    dispatch(setLoading({ type: "read", value: false }));
  }
};

export const getUserById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "getById", value: true }));
    let response;
    response = getUserByIdApi(id);
    const data = await response;
    dispatch(userByIdData(data));
  } catch (error) {
    const errorMessage = error.response.data.detail;
    dispatch(errorMessages(errorMessage));
  } finally {
    dispatch(setLoading({ type: "getById", value: false }));
  }
};

export const createUser = (data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "create", value: true }));
    await createUserApi(data);
    return { success: true, message: "User Successfully Created" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    return { success: false, message: errorMessage };
  } finally {
    dispatch(setLoading({ type: "create", value: false }));
  }
};

export const updateUser = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "update", value: true }));
    await updateUserApi(id, data);
    return { success: true, message: "User Successfully Updated" }
  } catch (error) {
    const errorMessage = error.response.data.errors;
    return { success: false, message: errorMessage };
  } finally {
    dispatch(setLoading({ type: "update", value: false }));
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "delete", value: true }));
    await deleteUserApi(id);
    return { success: true, message: "User Successfully Deleted" };
  } catch (error) {
    const errorMessage = error.response.data.errors;
    return { success: false, message: errorMessage };
  } finally {
    dispatch(setLoading({ type: "delete", value: false }));
  }
};
